module.exports = __webpack_public_path__ + "img/replace-uld.bc582897.svg";